/* Airway120 product page: page-wide behaviour only. Each part's own behaviour lives in assets/se-pro-<part>.js. */
(function () {
  var root = document.getElementById('se-pro');
  if (!root) return;

  /* STANDING RULE — URL-parameter passthrough.
     Forwards the visitor's entire landing-page query string to outbound
     internal links. Exclude `view` only. Hash links and off-site skipped. */
  (function () {
    var carry = [];
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (!value) return;
      if (key.toLowerCase() === 'view') return;
      carry.push([key, value]);
    });
    if (!carry.length) return;
    root.querySelectorAll('a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      try {
        var relative = href.indexOf('://') === -1;
        var target = new URL(href, window.location.href);
        if (!relative && target.host !== window.location.host) return;
        carry.forEach(function (pair) {
          if (!target.searchParams.has(pair[0])) {
            target.searchParams.set(pair[0], pair[1]);
          }
        });
        anchor.setAttribute('href', target.toString());
      } catch (error) {}
    });
  })();
})();
